import Decimal from 'decimal.js';

export function getOptimalPrecision(price: Decimal): number {
  const priceNum = price.toNumber();
  
  if (priceNum < 0.001) {
    return 10; // Very small prices like 0.0000342312
  } else if (priceNum < 0.01) {
    return 8; // Small prices like 0.00423412
  } else if (priceNum < 1) {
    return 6; // Prices like 0.423412
  } else if (priceNum < 100) {
    return 5; // Prices like 42.34512
  } else {
    return 4; // Large prices like 250.4512
  }
}

/**
 * Smart price formatting that adjusts precision based on magnitude
 */
export function formatPrice(price: Decimal, referencePrice?: Decimal): string {
  // Use reference price (like mid-price) to determine precision if available
  const priceForPrecision = referencePrice || price;
  const decimals = getOptimalPrecision(priceForPrecision);
  
  return price.toFixed(decimals);
}

/**
 * Format quantity with appropriate precision
 */
export function formatQuantity(quantity: Decimal, decimals: number = 4): string {
  return quantity.toFixed(decimals);
}

/**
 * Format percentage with consistent precision
 */
export function formatPercentage(percentage: number): string {
  const rounded = Math.round(percentage * 1000) / 1000; // Round to 0.001% precision
  return rounded >= 0 ? `+${rounded.toFixed(3)}%` : `${rounded.toFixed(3)}%`;
}

/**
 * Format time consistently
 */
export function formatTime(timestamp: Date): string {
  return timestamp.toLocaleTimeString('en-US', { 
    hour12: false, 
    hour: '2-digit', 
    minute: '2-digit', 
    second: '2-digit' 
  });
} 


const SOLSCAN_BASE_URL = "https://solscan.io/";

export function solscanUrl({account, tx}: {account?: string, tx?: string}): string {
    if (account) {
        return SOLSCAN_BASE_URL + "account/" + account;
    } else if (tx) {
        return SOLSCAN_BASE_URL + "tx/" + tx;
    } else {
        console.error("Unknown solscan link");
        return "#";
    }
}
